import { css } from "@compiled/react";
import { FormattedMessage, defineMessages } from "react-intl";

import { N700, N80 } from "@atlaskit/theme/colors";

import { ProductKey, getProductData } from "@/components/signup/utils";
import { DEFAULT_VALUES } from "@/libraries/web-framework";

const listItemStyle = css({
    margin: "8px"
});

const h3Style = css({
    fontWeight: "500",
    fontSize: "24px",
    color: N700,
    letterSpacing: "0.3px",
    marginBlockEnd: "8px"
});

const divStyle = css({
    fontSize: "16px",
    color: N80,
    fontWeight: "400",
    letterSpacing: "0.21px"
});

export const ProductTipListItem = ({
    productKey
}: {
    productKey: ProductKey;
}) => {
    const productName =
        ProductKey.SERVICE_COLLECTION === productKey
            ? "Service Collection"
            : getProductData(productKey).productName;
    const icuProductKey = productKey.replace("-", "_").replace(/\./g, "_");

    console.log("icuProductKey", icuProductKey);
    return (
        <li css={listItemStyle}>
            <h3 css={h3Style}>{productName}</h3>
            <div css={divStyle}>
                <FormattedMessage
                    {...ProductTipListItem.messages.productDescription}
                    values={{
                        icuProductKey,
                        ...DEFAULT_VALUES
                    }}
                />
            </div>
        </li>
    );
};

ProductTipListItem.messages = defineMessages({
    productDescription: {
        id: "WacConfirmationPage.productDescription",
        defaultMessage: `{ icuProductKey, select, 
          jira_ondemand {Keep track of projects and issues}
          greenhopper_jira_ondemand {Work using agile methods like Scrum and Kanban} 
          jira_software_ondemand {Collaborate and deliver projects as one team with the #1 project management tool.} 
          com_atlassian_servicedesk_ondemand {Manage queues and SLAs for IT and business teams} 
          com_atlassian_service_collection {Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast.}
          jira_servicedesk_ondemand {Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast.} 
          jira_incident_manager_ondemand {One place to respond, resolve, and learn from every incident} 
          com_radiantminds_roadmaps_jira_ondemand {Know when you can deliver, react to change and keep everyone on the same page} 
          bonfire_jira_ondemand {Rapid bug reporting for exploratory and session-based testing} 
          confluence_ondemand {Organize your work, create documents, and discuss everything in one place.} 
          com_atlassian_confluence_plugins_confluence_questions_ondemand {Capture, learn from, and retain the collective knowledge of your organization as it grows} 
          team_calendars_confluence_ondemand {Your team's single source of truth for managing team leave, tracking Jira projects, and planning events}
          other {{br}\n}
        }`
    }
});
